import { apiClient } from './backendURL';
import Cookies from 'js-cookie';

export const getVisitorStatsAPI = () => {
    const token = Cookies.get('accessToken');
    return apiClient.get('/visitor/stats', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const recordVisitAPI = (page: string) =>
    apiClient.post('/visitor/record', { page });
